var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 665,
    viewBox: "0 0 343 665",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M299.997 70.6543C300.016 78.2093 296.99 85.4727 291.564 90.8956C286.137 96.3185 278.74 99.4719 270.949 99.6833C263.159 99.8948 255.591 97.1475 249.86 92.0274C244.13 86.9073 240.689 79.8194 240.272 72.2752",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.339 86.9277C263.339 86.9277 270.113 92.0623 276.887 87.2811",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M270.113 74.0195V84.0153L273.908 83.9945",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M261.861 79.9643C265.401 79.9643 268.27 77.1824 268.27 73.7507C268.27 70.319 265.401 67.5371 261.861 67.5371C258.32 67.5371 255.451 70.319 255.451 73.7507C255.451 77.1824 258.32 79.9643 261.861 79.9643Z",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M278.302 79.9643C281.842 79.9643 284.712 77.1824 284.712 73.7507C284.712 70.319 281.842 67.5371 278.302 67.5371C274.762 67.5371 271.892 70.319 271.892 73.7507C271.892 77.1824 274.762 79.9643 278.302 79.9643Z",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M268.269 73.7539H271.87",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M272.022 55.7731C279.457 55.7731 285.485 49.9301 285.485 42.7225C285.485 35.5148 279.457 29.6719 272.022 29.6719C264.587 29.6719 258.559 35.5148 258.559 42.7225C258.559 49.9301 264.587 55.7731 272.022 55.7731Z",
    fill: "#FE6571"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M266.297 57.4353C264.92 60.3492 262.872 62.9188 260.312 64.9468C257.752 66.9749 254.746 68.4076 251.526 69.1351C247.853 70.1258 244.027 70.4707 240.229 70.1534C240.374 62.7469 243.44 55.6757 248.798 50.3935C254.155 45.1112 261.397 42.0192 269.034 41.7531C276.67 41.487 284.122 44.067 289.857 48.9628C295.592 53.8585 299.174 60.698 299.868 68.0752C292.107 66.5374 293.072 61.072 280.445 62.7553C268.912 64.2307 266.297 57.4353 266.297 57.4353Z",
    fill: "#FE6571"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M258.73 43.8446C262.855 41.8556 267.449 40.9598 272.046 41.2481C276.643 41.5365 281.079 42.9987 284.905 45.4864",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0023 70.6554C42.9915 64.9717 44.7144 59.4118 47.9544 54.6747C38.7148 64.421 37.8145 98.149 37.8145 98.149H63.5395C57.5786 96.2264 52.3904 92.539 48.7059 87.6065C45.0215 82.6741 43.0266 76.7452 43.0023 70.6554Z",
    fill: "#3098F3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.74 55.7127C95.7565 50.7245 91.2674 46.7426 85.8775 44.3038C83.1656 43.0488 80.2753 42.1942 77.3025 41.7685C76.0049 41.565 74.6937 41.4539 73.3794 41.436C69.3715 41.3756 65.391 42.0852 61.6675 43.5239C57.944 44.9626 54.5514 47.1019 51.6853 49.8184C48.8193 52.5349 46.5366 55.7747 44.969 59.3509C43.4015 62.9271 42.5801 66.7689 42.5522 70.6544H89.4147C89.4147 70.6544 89.9721 65.7708 90.2722 64.4201C91.4941 58.8923 92.8447 57.6869 92.8447 57.6869C97.6038 67.4957 102.556 70.9454 102.749 71.07C102.648 77.0722 100.625 82.8956 96.9615 87.7353C93.2978 92.5749 88.1737 96.1917 82.2974 98.0856H106.736C106.736 98.0856 107.808 67.9944 98.74 55.7127Z",
    fill: "#3098F3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.772 70.6551C102.749 75.1264 101.663 79.5323 99.5979 83.5307C97.5331 87.529 94.5455 91.0123 90.8669 93.7098C87.1883 96.4074 82.9178 98.2468 78.387 99.0851C73.8562 99.9234 69.1871 99.7381 64.7422 98.5435",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1133 86.9286C66.1133 86.9286 72.8875 92.0632 79.6618 87.2819",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8887 74.0204V84.0161L76.6831 83.9953",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6359 79.9651C68.1759 79.9651 71.0457 77.1832 71.0457 73.7515C71.0457 70.3199 68.1759 67.5379 64.6359 67.5379C61.0958 67.5379 58.2261 70.3199 58.2261 73.7515C58.2261 77.1832 61.0958 79.9651 64.6359 79.9651Z",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0768 79.9651C84.6169 79.9651 87.4866 77.1832 87.4866 73.7515C87.4866 70.3199 84.6169 67.5379 81.0768 67.5379C77.5368 67.5379 74.667 70.3199 74.667 73.7515C74.667 77.1832 77.5368 79.9651 81.0768 79.9651Z",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0439 73.7547H74.6455",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M102.643 422.4C102.083 428.345 99.6416 433.977 95.6536 438.525C91.6656 443.074 86.3254 446.317 80.3634 447.812C74.4014 449.306 68.1087 448.978 62.3461 446.874C56.5835 444.769 51.6324 440.99 48.1699 436.053",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9651 393.431C83.5034 392.289 80.8926 391.478 78.2047 391.021C75.0678 388.048 71.096 386.038 66.7866 385.244C62.4771 384.449 58.0216 384.904 53.9778 386.552C49.934 388.201 46.4817 390.969 44.0531 394.51C41.6245 398.051 40.3275 402.209 40.3246 406.461C40.3241 407.392 40.3886 408.323 40.5176 409.246C28.1267 415.833 27.2263 429.237 27.8694 434.329H47.0346C44.4082 429.905 43.0397 424.885 43.0686 419.782C74.8176 418.306 74.8176 399.769 74.8176 399.769C76.7255 421.777 103.265 420.052 103.265 420.052C103.273 414.483 101.652 409.026 98.5902 404.314C95.5281 399.602 91.1504 395.829 85.9651 393.431Z",
    fill: "#FFCC00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4753 390.898C76.1706 390.694 74.8523 390.583 73.5308 390.565C69.5069 390.48 65.5056 391.171 61.7597 392.598C58.0139 394.026 54.5983 396.161 51.7116 398.88C48.825 401.599 46.525 404.847 44.9454 408.436C43.3658 412.025 42.5382 415.882 42.5107 419.784",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1133 436.074C66.1133 436.074 72.8875 441.188 79.6618 436.406",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8887 423.146V433.142H76.6831",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6359 429.091C68.1759 429.091 71.0457 426.309 71.0457 422.877C71.0457 419.445 68.1759 416.664 64.6359 416.664C61.0958 416.664 58.2261 419.445 58.2261 422.877C58.2261 426.309 61.0958 429.091 64.6359 429.091Z",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0768 429.091C84.6169 429.091 87.4866 426.309 87.4866 422.877C87.4866 419.445 84.6169 416.664 81.0768 416.664C77.5368 416.664 74.667 419.445 74.667 422.877C74.667 426.309 77.5368 429.091 81.0768 429.091Z",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0439 422.88H74.6455",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M301.84 401.7C299.067 399.191 297.342 395.782 296.995 392.12C296.785 390.183 296.241 388.293 295.387 386.53C293.635 382.806 290.513 379.85 286.631 378.24C282.75 376.63 278.388 376.481 274.4 377.823C271.45 378.888 268.852 380.705 266.878 383.083C264.905 385.46 263.63 388.309 263.188 391.33C254.248 392.66 243.079 397.336 238.942 410.906C237.484 415.624 235.812 419.78 229.617 421.858C222.757 424.102 218.298 428.508 217.547 435.47C217.138 439.638 218.027 443.829 220.098 447.502H261.237C255.137 445.667 249.806 441.984 246.024 436.994C242.243 432.004 240.212 425.971 240.228 419.78V419.281C240.228 419.281 242.479 416.247 249.875 413.795C256.306 411.717 260.594 413.566 265.932 412.818C267.276 413.275 268.688 413.52 270.112 413.546C272.601 413.539 275.041 412.875 277.171 411.627C279.301 410.379 281.04 408.592 282.203 406.459C283.829 408.206 285.616 409.806 287.541 411.239C291.329 414.26 295.474 416.834 299.889 418.907C299.889 419.219 299.889 419.531 299.889 419.842C299.89 420.919 299.826 421.994 299.696 423.063C301.558 422.178 303.161 420.854 304.36 419.213C305.558 417.573 306.313 415.667 306.556 413.67C306.823 411.454 306.534 409.209 305.713 407.124C304.892 405.04 303.563 403.179 301.84 401.7Z",
    fill: "#FE6571"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M294.722 436.611C291.966 440.371 288.321 443.435 284.091 445.547C279.861 447.659 275.17 448.756 270.412 448.748C268.03 448.745 265.655 448.473 263.338 447.937",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M263.338 436.053C263.338 436.053 270.112 441.187 276.886 436.406",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M270.113 423.146V433.142L273.908 433.121",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M261.861 429.091C265.401 429.091 268.27 426.309 268.27 422.878C268.27 419.446 265.401 416.664 261.861 416.664C258.32 416.664 255.451 419.446 255.451 422.878C255.451 426.309 258.32 429.091 261.861 429.091Z",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M278.302 429.091C281.842 429.091 284.712 426.309 284.712 422.878C284.712 419.446 281.842 416.664 278.302 416.664C274.762 416.664 271.892 419.446 271.892 422.878C271.892 426.309 274.762 429.091 278.302 429.091Z",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M268.269 422.879H271.87",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M282.61 393.474C281.525 391.182 279.787 389.239 277.601 387.873C275.415 386.506 272.872 385.773 270.271 385.76C267.67 385.747 265.119 386.454 262.918 387.799C260.718 389.143 258.959 391.069 257.85 393.349C261.748 391.661 265.974 390.799 270.244 390.821C274.514 390.842 278.729 391.747 282.61 393.474Z",
    fill: "#FFCC00"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8887 248.585L72.9101 258.58L76.6831 258.56",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1133 261.489C66.1133 261.489 72.8875 266.624 79.6618 261.842",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4968 262.05C94.6977 265.851 90.9919 268.94 86.6953 271.054C82.3987 273.167 77.6388 274.242 72.8211 274.187C68.0035 274.132 63.271 272.948 59.0271 270.737C54.7831 268.526 51.1536 265.353 48.4478 261.489",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M108.602 234.414C107.566 233.586 106.739 232.54 106.182 231.355C105.624 230.171 105.353 228.879 105.387 227.577V227.203C105.36 223.389 103.799 219.736 101.037 217.019C98.2747 214.303 94.5285 212.738 90.5947 212.656C88.7162 212.635 86.8494 212.945 85.0852 213.571C84.1165 213.908 83.0734 213.991 82.0609 213.812C81.0485 213.633 80.1025 213.199 79.3185 212.553C77.6139 211.11 75.5948 210.061 73.4125 209.482C71.2302 208.903 68.941 208.809 66.7164 209.209C64.4917 209.609 62.389 210.491 60.5657 211.79C58.7424 213.089 57.2457 214.77 56.1875 216.709H54.8798C51.2089 216.665 47.6509 217.938 44.8899 220.283C42.3354 222.522 40.6358 225.532 40.0664 228.824C39.5813 231.231 38.3818 233.449 36.615 235.204C34.6328 237.221 33.2896 239.747 32.745 242.482C32.2005 245.217 32.4775 248.046 33.5432 250.633C34.6089 253.22 36.4183 255.456 38.7566 257.075C41.0948 258.695 43.8635 259.629 46.7335 259.768H47.4409C44.7835 255.354 43.392 250.331 43.4107 245.221C48.8129 240.379 57.7953 241.979 64.591 240.337C80.3475 236.534 82.8772 224.294 82.8772 224.294C84.1634 243.891 99.234 245.428 103.157 245.491C103.139 250.709 101.657 255.823 98.8696 260.287C102.001 260.352 105.076 259.465 107.661 257.75C110.247 256.036 112.214 253.58 113.287 250.727C114.361 247.874 114.486 244.767 113.646 241.842C112.805 238.916 111.042 236.319 108.602 234.414Z",
    fill: "#3098F3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M270.113 248.584L270.135 258.58L273.908 258.559",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M263.339 261.488C263.339 261.488 270.113 266.623 276.887 261.842",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M285.119 220.28C283.249 218.168 280.931 216.473 278.322 215.311C275.713 214.149 272.876 213.547 270.005 213.547C267.134 213.547 264.297 214.149 261.689 215.311C259.08 216.473 256.761 218.168 254.892 220.28C249.474 223.388 245.206 228.075 242.696 233.672C240.186 239.269 239.563 245.491 240.915 251.452C241.641 248.763 243.126 246.324 245.202 244.407C248.289 241.706 252.962 238.36 253.991 232.749H285.119C285.512 234.593 286.284 236.342 287.389 237.892C288.494 239.441 289.909 240.759 291.55 241.768C293.951 243.243 298.196 243.846 299.696 249.623C299.903 248.163 300.003 246.691 299.996 245.218C299.976 240.164 298.592 235.204 295.982 230.829C293.372 226.454 289.627 222.818 285.119 220.28Z",
    fill: "#3098F3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M299.245 252.824C297.542 258.896 293.846 264.265 288.716 268.12C283.585 271.974 277.3 274.105 270.81 274.189C264.319 274.274 257.977 272.308 252.742 268.588C247.507 264.868 243.663 259.597 241.792 253.572",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M102.686 596.694C102.083 603.951 98.6836 610.721 93.1639 615.658C87.6442 620.595 80.4092 623.337 72.8988 623.337C65.3884 623.337 58.1534 620.595 52.6337 615.658C47.114 610.721 43.7143 603.951 43.1113 596.694",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8887 597.707L72.9101 607.703L76.6831 607.682",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1133 610.614C66.1133 610.614 72.8875 615.748 79.6618 610.967",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M102.772 573.123H93.2535C88.9898 569.287 83.6644 566.739 77.9297 565.793C72.1951 564.846 66.3001 565.541 60.9668 567.793C55.6336 570.045 51.0936 573.756 47.9031 578.471C44.7126 583.186 43.01 588.701 43.0039 594.341C43.6907 592.375 44.7981 590.572 46.2537 589.05C47.7093 587.528 49.4801 586.321 51.4503 585.509C57.5814 582.558 62.4692 584.947 69.6293 582.412C72.6423 581.625 75.2656 579.819 77.0253 577.321C78.4699 579.432 80.458 581.14 82.7929 582.277C85.1279 583.414 87.7287 583.941 90.338 583.805C91.9119 583.819 93.4817 583.645 95.0113 583.285C98.3071 585.896 100.946 589.201 102.729 592.948C102.538 588.84 101.434 584.821 99.4918 581.165C100.645 580.164 101.542 578.916 102.112 577.52C102.681 576.124 102.907 574.618 102.772 573.123Z",
    fill: "#3098F3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M283.19 567.992C280.477 566.74 277.587 565.886 274.615 565.457C273.31 565.254 271.992 565.142 270.67 565.125C266.653 565.05 262.661 565.749 258.925 567.182C255.189 568.614 251.784 570.752 248.907 573.469C246.029 576.187 243.737 579.432 242.163 583.015C240.588 586.598 239.763 590.448 239.736 594.343C271.892 593.034 279.845 576.513 279.845 576.513C285.762 593.678 300.425 594.592 300.425 594.592C300.435 589.034 298.822 583.586 295.772 578.878C292.722 574.171 288.36 570.397 283.19 567.992Z",
    fill: "#FFCC00"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M299.911 596.693C299.308 603.95 295.908 610.721 290.388 615.658C284.869 620.595 277.634 623.337 270.123 623.337C262.613 623.337 255.378 620.595 249.858 615.658C244.339 610.721 240.939 603.95 240.336 596.693",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M270.113 597.707L270.135 607.703L273.908 607.682",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M263.339 610.613C263.339 610.613 270.113 615.748 276.887 610.967",
    stroke: "#082C4E",
    strokeWidth: 2.07879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceStyle);
export default __webpack_public_path__ + "static/media/face-style.135d1ea1b7e8ca44200b398caa51d7cb.svg";
export { ForwardRef as ReactComponent };